module.exports = __webpack_public_path__ + "static/media/member nalas-14.e396fb1c.jpg";